var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('van-cell-group',{staticClass:"user-info-cell-group"},[_c('van-cell',{attrs:{"title":"手机号","value":_vm.webUserInfo.mobilePhone,"size":"large","to":"/user/bind-phone","is-link":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }